import { configureStore } from '@reduxjs/toolkit';
import CreateUser from "./reducer/CreateUser";
import TenantRegestration from './reducer/TenantRegestration';
import RentSetting from './reducer/RentSetting';
import AccountSetting from './reducer/AccountSetting';
import ElectricReading from './reducer/ElectricReading';
import SendEmail from './reducer/SendEmail';
import KElectricImg from './reducer/KElectricImg';
import SsgcReading from './reducer/SsgcReading';
import WaterReading from './reducer/WaterReading';
import MaintananceReading from './reducer/MaintananceReading';
import TrashReading from './reducer/TrashReading';
import RentReading from './reducer/RentReading';
import SecurityReading from './reducer/SecurityReading';
import agreementViolation from './reducer/AgreementViolation';
import GetOneUploadBill from './reducer/GetOneUploadBill';
import PropertyRegistration from './reducer/PropertyRegistration';
import GetTenantDetail from './reducer/GetTenantDetail';
import LoginUser from './reducer/LoginUser';
import ValidateUser from './reducer/ValidateUser';
import AcceptRequest from './reducer/AcceptRequest';
import GetAllTenant from './reducer/GetAllTenant';
import RejectRequest from './reducer/RejectRequest';
import GetOneAgreement from './reducer/GetOneAgreement';
import GetAppliedFlatDetail from './reducer/GetAppliedFlat';
import GetOneTenantAgreementDetail from "./reducer/GetOneTenantAgreement"
import GetTenantCurrentBill from './reducer/GetTenantCurrentBill';
import UpdateElectricReading from './reducer/UpdateElectricReading';
import Profile from './reducer/Profile';
import sidebarReducer from "./reducer/SidebarSlice";
import flatRegister from './reducer/flatRegister';
import GetPropertyDetails from './reducer/GetPropertyDetails';
import GetAllLandlordMaintenanceRequest from './reducer/GetAllLandlordMaintenanceRequest';
import RequestResponseLandlord from './reducer/RequestResponseLandlord';
import GetAllTenantMaintenanceRequest from './reducer/GetAllTenantMaintenanceRequest';
import MaintenanceRequestTenant from './reducer/MaintenanceRequestTenant';
// import SendMsg from "./reducer/SendChat"
import SendChat from './reducer/SendChat';
import GetAllMaintenanceRequestChat  from './reducer/GetMaintenanceRequestChat';
import GetAdminDetail from './reducer/GetAdminDetail';
import AcceptLandlord from './reducer/AcceptRejectAdmin';
import RejectLandlord from './reducer/AcceptRejectAdmin';
import AcceptProperty from './reducer/AcceptPropertyAdmin';
import OtsFeeReceipts from './reducer/OtsFeeReceipts';
import TenantFunnel from './reducer/TenantFunnel';
import SafePayPayment from './reducer/SafePayPayment';
import FlatInterestRequest from './reducer/FlatInterestRequest';
import GetTenantProfile from './reducer/GetTenantProfile';
import UpdateTenantProfile from './reducer/UpdateTenantProfile';
import OwnerRegistration from './reducer/OwnerRegistration';
import OTPReducer from './reducer/OTPReducer';
import DashboardStats from './reducer/DashboardStats';
import AdminAuth from './reducer/AdminAuth';
import AdminOTP from './reducer/AdminOTP';
import UpdateAdminProfile from './reducer/UpdateAdminProfile';
import Tenancy from './reducer/Tenancy';
import EscrowTransaction from './reducer/EscrowTransaction';
import RentPayment from './reducer/RentPayment';
import OTSWallet from './reducer/OTSWallet';
import SystemSettings from './reducer/SystemSettings';
import notificationSlice from './reducer/GetNotifications';
import propertyCondition from './reducer/PropertyCondition';
import propertyReview from './reducer/PropertyReview';
import settlementBill from './reducer/SettlementBill';

export const store = configureStore({
  reducer: {
    "UserAdd": CreateUser,
    "loginUser": LoginUser,
    "validateUser": ValidateUser,
    "TenantRegestration": TenantRegestration,
    "rentSetting": RentSetting,
    "accountSetting": AccountSetting,
    "electricReading": ElectricReading,
    "ssgcReading": SsgcReading,
    "waterReading": WaterReading,
    "maintananceReading": MaintananceReading,
    "trashReading": TrashReading,
    "rentReading": RentReading,
    "securityReading": SecurityReading,
    "agreementViolation": agreementViolation,
    "SendEmail":SendEmail,
    "Photo": KElectricImg,
    "getOneUploadBillDetail": GetOneUploadBill,
    "propertyRegistration": PropertyRegistration,
    "AcceptRequest": AcceptRequest,
    "tenantDetail": GetTenantDetail,
    "allTenant": GetAllTenant,
    "RejectRequest": RejectRequest,
    "GetOneAgreementDetail": GetOneAgreement,
    "appliedFlatDetail": GetAppliedFlatDetail,
    "GetOneTenantAgreementDetail": GetOneTenantAgreementDetail,
    "GetTenantCurrentBill": GetTenantCurrentBill,
    "updateElectricReading": UpdateElectricReading,
    "profile": Profile,
    "sidebar": sidebarReducer,
    "flatRegister":flatRegister,
    "getPropertyDetails":GetPropertyDetails,
    "landlordMaintenanceRequest":GetAllLandlordMaintenanceRequest,
    "RequestResponse":RequestResponseLandlord,
    "tenantMaintenanceRequest":GetAllTenantMaintenanceRequest,
    "CreateTenantMaintenanceRequest":MaintenanceRequestTenant,
    "SendMsg":SendChat,
    "maintenanceRequestChat":GetAllMaintenanceRequestChat,
    "getAdminDetail":GetAdminDetail,
    "AcceptLandlord": AcceptLandlord,
    "RejectLandlord": RejectLandlord,
    "AcceptProperty":AcceptProperty,
    "otsFeeReceipts": OtsFeeReceipts,
    "tenantFunnel": TenantFunnel,
    "safepay": SafePayPayment,
    "flatInterest": FlatInterestRequest,
    "getTenantProfile": GetTenantProfile,
    "updateTenantProfile": UpdateTenantProfile,
    "ownerRegistration": OwnerRegistration,
    "otp": OTPReducer,
    "dashboardStats": DashboardStats,
    "adminAuth": AdminAuth,
    "adminOTP": AdminOTP,
    "updateAdminProfile": UpdateAdminProfile,
    "tenancy": Tenancy,
    "escrow": EscrowTransaction,
    "rentPayment": RentPayment,
    "otsWallet": OTSWallet,
    "systemSettings": SystemSettings,
    "notificationSlice": notificationSlice,
    "propertyCondition": propertyCondition,
    "propertyReview": propertyReview,
    "settlementBill": settlementBill
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        // Ignore these paths in the state
        ignoredPaths: [
          'loginUser.login.headers',
          'validateUser.UserValidate.headers',
          'profile.profile.headers',
          'getAdminDetail.adminDetail.headers',
        ],
      },
    }),
})